





























































































































import { Component, Watch, Vue } from "vue-property-decorator";

import localforage from "localforage";
import environment from './env';

type LogoType = 'default' | 'marketing' | 'design' | 'technology';

interface SignData {
  email: string;
  firstname: string;
  lastname: string;
  job: string;
  logoType: LogoType;
  phone: string;
}

@Component({
  components: {}
})
export default class App extends Vue {
  private data?: SignData | null = null;

  private showProcedure: boolean = false;
  async mounted() {
    this.data = await localforage.getItem<SignData>("data");

    if (this.data == null) {
      this.data = {
        email:'',
        firstname:'',
        lastname:'',
        job:'',
        logoType: 'default',
        phone: ''
      };
    }
  }

  @Watch('data', { deep: true})
  async onChangeData() {
    if (this.data) {
      await localforage.setItem<SignData>("data", this.data);
    }
  }

  get imageLink() {
    if (this.data) {
      return `https://${environment.domain}/images/logo-${this.data.logoType}.png`;
    }
  }

  getWebsiteUrl(source: string) {
    if (this.data) {
      const origin = this.data.firstname.toLowerCase()+'.'+ this.data.lastname.toLowerCase();
      return `https://www.yabawt.com/?utm_source=mail&utm_medium=sign&utm_content=${source}&` + 
        `utm_term=${encodeURIComponent(origin)}`;
    }
  }

  getMapUrl() {
    return `https://goo.gl/maps/XPRVTMbfPRS2`;
  }

  get formatPhone() {
    if (this.data && this.data.phone) {
      const matches = this.data.phone.match(/.{1,2}/g);
      if (matches) {
        return `+33 (0)`+ matches.join(' ').substring(1);
      }
    }
  }
}
